import { render, staticRenderFns } from "./left.vue?vue&type=template&id=2189091a&scoped=true&"
import script from "./left.vue?vue&type=script&lang=js&"
export * from "./left.vue?vue&type=script&lang=js&"
import style0 from "./left.vue?vue&type=style&index=0&id=2189091a&scoped=true&lang=less&"
import style1 from "./left.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2189091a",
  null
  
)

export default component.exports